import Dashboard from "layouts/dashboard";
import Maintenance from "layouts/maintenance";
import Tables from "layouts/vendor-directory";
import Billing from "layouts/billing";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import SiteMap from "layouts/sitemaps";
import Local_Link from "layouts/local_link";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Calendar from "layouts/Calendar";
import Library from "layouts/library";
import Reservations from "layouts/reservations";
import PetRegistry from "layouts/petregistry";
import Property from "layouts/manager/property";

// HG Pro icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';

const routes = [
  // {
  //   type: "collapse",
  //   name: "Users",
  //   key: "users",
  //   route: "/admin/user",
  //   icon: <CustomerSupport size="12px" />,
  //   component: null,
  //   noCollapse: false,
  //   children: [

  //   ]
  // },
    // {
    //   type: "collapse",
    //   name: "Dashboard",
    //   key: "unit",
    //   route: "/super-admin/dashboard",
    //   activePaths: ["/super-admin/dashboard"],
    //   icon: <SpaceDashboardIcon size="12px" />,
    //   component: <Property />,
    //   noCollapse: true,
    //   children: []
    // },

    {
    type: "collapse",
    name: "Organization",
    key: "organization",
    route: "/super-admin/organization",
    activePaths: ["/super-admin/organization", "/super-admin/admin", "/super-admin"], // 👈 add this
    icon: <CustomerSupport size="12px" />,
    component: null,
    noCollapse: false,
    children: []
  },

  // {
  //   type: "collapse",
  //   name: "Property",
  //   key: "property",
  //   route: "/admin/properties",
  //   icon: <Shop size="12px" />,
  //   component: <Property />,
  //   noCollapse: true,
  //   children: [


  //   ]
  // },


];

export default routes;
